import { FC, useCallback } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import FormRadio from '@components/FormRadio/FormRadio';
import ModalForm from '@components/ModalForm/ModalForm';

import { IFormRiskLevelValue } from '../FormRiskLevels.interface';

import { IFormRiskLevelsModalProps } from './FormRiskLevelsModal.interface';

import './style.scss';

const formId = 'admin-risk-level-modal';

const FormRiskLevelsModal: FC<IFormRiskLevelsModalProps> = ({
  open,
  options,
  currentItem,
  onApply,
  onClose,
  onExited,
}) => {
  const { t } = useTranslation();

  const handleValidate = useCallback((item: IFormRiskLevelValue) => {
    const errors: Partial<Record<keyof IFormRiskLevelValue, string | boolean>> = {};
    if (!item.riskLevelDescriptionId) errors.riskLevelDescriptionId = true;
    return errors;
  }, []);

  const handleSubmit = useCallback(
    (item: IFormRiskLevelValue) => {
      onApply(item);
      onClose();
    },
    [onApply, onClose],
  );

  return (
    <ModalForm<IFormRiskLevelValue>
      onClose={onClose}
      onExited={onExited}
      open={open}
      formId={formId}
      title={t('admin.selectRiskLevelDescription', { level: currentItem?.riskLevelId })}
      className="form-risk-levels-modal"
      leftActionTitle={t('common.cancel')}
      onLeftAction={onClose}
      rightActionTitle={t('admin.save')}
      initialValues={currentItem}
      validate={handleValidate}
      onSubmit={handleSubmit}
    >
      {({ handleSubmit }) => (
        <form id={formId} onSubmit={handleSubmit}>
          <Field
            component={FormRadio}
            className="form-risk-levels-modal__option"
            name="riskLevelDescriptionId"
            options={options}
            type="number"
          />
        </form>
      )}
    </ModalForm>
  );
};

export default FormRiskLevelsModal;
